module.exports = __webpack_public_path__ + "static/media/her.911b0243.jpg";